/**
 * Browser localStorage access with a fixed set of stored variable names.
 */
export class LocalStorageUtils {
  /** Keys for values stored in localStorage. */
  static readonly Keys = {
    REVENUECAT_ANONYMOUS_USER_ID: 'rc_anonymous_user_id',
  } as const;

  private static getStorage(): Storage | null {
    if (typeof window === 'undefined' || window.localStorage == null) {
      return null;
    }
    return window.localStorage;
  }

  static get(key: string): string | null {
    const storage = LocalStorageUtils.getStorage();
    if (!storage) return null;
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  }

  static set(key: string, value: string): void {
    const storage = LocalStorageUtils.getStorage();
    if (!storage) return;
    try {
      storage.setItem(key, value);
    } catch {
      // ignore quota or access errors
    }
  }

  static remove(key: string): void {
    const storage = LocalStorageUtils.getStorage();
    if (!storage) return;
    try {
      storage.removeItem(key);
    } catch {
      // ignore
    }
  }
}
